import { useEffect, useState } from 'react'
import Card from 'react-bootstrap/Card'

import { getPricingLevelPerformance } from '../../utilities/api'

import PricingLevelPerformanceMatrix from './PricingLevelPerformanceMatrix'

export default function DashboardPricingLevelMatrix({
  organizationUUID,
  eventUUID,
  isRefreshing,
}) {
  const [reportData, setReportData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [loadError, setLoadError] = useState(null)

  useEffect(() => {
    if (isRefreshing || !organizationUUID || !eventUUID) return

    let cancelled = false
    setIsLoading(true)
    setLoadError(null)

    getPricingLevelPerformance(organizationUUID, eventUUID)
      .then((res) => {
        if (cancelled) return
        setReportData(res?.data ?? null)
      })
      .catch((err) => {
        if (cancelled) return
        console.error('Failed to load pricing level performance', err)
        setLoadError('Could not load pricing level performance for this event.')
        setReportData(null)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [organizationUUID, eventUUID, isRefreshing])

  if (!organizationUUID || !eventUUID) return null

  const rows = reportData?.rows || []

  return (
    <div className="pricing-level-performance-wrapper">
      {isLoading && (
        <Card body className="card--light">
          <h1 className="h5 mb-0">Performance matrix</h1>
          <p className="text-muted small mb-0 mt-2">Loading…</p>
        </Card>
      )}

      {!isLoading && loadError && (
        <Card body className="card--light">
          <h1 className="h5 mb-2">Performance matrix</h1>
          <p className="text-danger mb-0">{loadError}</p>
        </Card>
      )}

      {!isLoading && !loadError && reportData?.error === 'event_not_found' && (
        <Card body className="card--light">
          <h1 className="h5 mb-2">Performance matrix</h1>
          <p className="text-muted mb-0">
            Event not found for this organization.
          </p>
        </Card>
      )}

      {!isLoading &&
        !loadError &&
        reportData &&
        !reportData.error &&
        rows.length === 0 && (
          <Card body className="card--light">
            <h1 className="h5 mb-2">Performance matrix</h1>
            <p className="text-muted mb-0">
              No pricing level snapshots yet for this event. Run the pricing
              level snapshot backfill or daily job, then refresh this report.
            </p>
          </Card>
        )}

      {!isLoading && rows.length > 0 && (
        <PricingLevelPerformanceMatrix
          rows={rows}
          cardClassName="card--light pricing-level-performance-matrix-card"
          titleAs="h1"
        />
      )}
    </div>
  )
}
